export const validPasswordFormat = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/)

export default function isValidPassword(input) {
  let isValid = true
  if (input.length > 1) {
    isValid = validPasswordFormat.test(input)
  }

  return isValid
}
